// extracted by mini-css-extract-plugin
export default {"container":"StatisticFilter_container__4wCrR"};